import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PLANT_OVERVIEW_COUNTRIES } from '@common';
import { AuthStore } from '@store';

@Component({
  selector: 'app-plant-overview-link',
  templateUrl: './plant-overview-link.component.html',
  styleUrls: ['./plant-overview-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlantOverviewLinkComponent {
  @Input() overviewUrl: string;
  plantOverviewCountries = PLANT_OVERVIEW_COUNTRIES;

  navigateToHeatingSystemOverview(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    window.open(this.overviewUrl, '_blank');
  }

  constructor(public authStore: AuthStore) {}
}
